import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";

import { useRequestHeaders } from "../../../../core/hooks/useRequestHeaders";
import { AuthContext } from "../../../../core/providers/AuthContext";
import { useSurveysStore } from "../SurveysState";

const useSurveys = () => {
  const {
    loadingSurverys,
    surveys,
    showSurveysDialog,
    fetchSurveys,
    resetSurveyStore,
    continuePressed,
    skipPressed,
    skipPressedDay,
    continueSurvey,
    skipSurvey,
    loadingSendResults,
    showThankYou,
    sendSurveyResult,
    closeSurveyDialog,
    openSurveyDialog,
    closedSurveyInMiddle,
    //results
    showSurveyResult,
    showSurveyResultSkipped,
    openShowSurveyResultDialog,
    closeShowSurveyResultDialog,
    fetchShowSurveysResults,
    loadingShowSurveysResults,
    recoverShowSurveyResultSkippedState,
  } = useSurveysStore((state) => ({
    loadingSurverys: state.loadingSurverys,
    surveys: state.surveys,
    showSurveysDialog: state.showSurveysDialog,
    fetchSurveys: state.fetchSurveys,
    resetSurveyStore: state.resetSurveyStore,
    continuePressed: state.continuePressed,
    skipPressed: state.skipPressed,
    skipPressedDay: state.skipPressedDay,
    continueSurvey: state.continueSurvey,
    skipSurvey: state.skipSurvey,
    loadingSendResults: state.loadingSendResults,
    showThankYou: state.showThankYou,
    sendSurveyResult: state.sendSurveyResult,
    closeSurveyDialog: state.closeSurveyDialog,
    openSurveyDialog: state.openSurveyDialog,
    closedSurveyInMiddle: state.closedSurveyInMiddle,
    //results
    fetchShowSurveysResults: state.fetchShowSurveysResults,
    showSurveyResult: state.showSurveyResult,
    showSurveyResultSkipped: state.showSurveyResultSkipped,
    openShowSurveyResultDialog: state.openShowSurveyResultDialog,
    closeShowSurveyResultDialog: state.closeShowSurveyResultDialog,
    loadingShowSurveysResults: state.loadingShowSurveysResults,
    recoverShowSurveyResultSkippedState:
      state.recoverShowSurveyResultSkippedState,
  }));

  const { t } = useTranslation();
  const headers = useRequestHeaders();
  const { logout } = useContext(AuthContext);

  const handleFetchSurveys = useCallback(() => {
    fetchSurveys({ t, headers, logout });
  }, [fetchSurveys, headers, logout, t]);

  const handleSendSurveyResults = useCallback(
    async ({ ratings, comment, surveyCode }) => {
      sendSurveyResult({ t, headers, logout, comment, ratings, surveyCode });
    },
    [sendSurveyResult, headers, logout, t]
  );

  const handleFetchSurveysResult = useCallback(() => {
    fetchShowSurveysResults({ headers, logout, t });
  }, [fetchShowSurveysResults, headers, logout, t]);

  return {
    loadingSurverys,
    surveys,
    showSurveysDialog,
    handleFetchSurveys,
    resetSurveyStore,
    continuePressed,
    skipPressed,
    skipPressedDay,
    continueSurvey,
    skipSurvey,
    handleSendSurveyResults,
    loadingSendResults,
    showThankYou,
    closeSurveyDialog,
    openSurveyDialog,
    closedSurveyInMiddle,
    //results
    handleFetchSurveysResult,
    showSurveyResult,
    showSurveyResultSkipped,
    openShowSurveyResultDialog,
    closeShowSurveyResultDialog,
    loadingShowSurveysResults,
    recoverShowSurveyResultSkippedState,
  };
};

export default useSurveys;
